import { Slideshow } from '@/components/Slideshow/Slideshow'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { type SbBlokData, StoryblokComponent, storyblokEditable } from '@storyblok/react'

type SlideshowBlockProps = SbBaseBlockProps<{
  items: Array<SbBlokData>
}>

export function SlideshowBlock({ blok }: SlideshowBlockProps) {
  return (
    <Slideshow {...storyblokEditable(blok)}>
      {blok.items?.map((nestedBlok) => (
        <StoryblokComponent key={nestedBlok._uid} blok={nestedBlok} nested={true} />
      ))}
    </Slideshow>
  )
}
